<div class="main-popup mt-3">
    <div class="main-title-popup mb-4 text-center">
        <h1>Mortality</h1>
    </div>
    <form [formGroup]="mortalityForm" (ngSubmit)="onSave()">
        <div class="row">
            <!-- Farm - Full Width Row -->
            <div class="col-md-12 mb-3">
                <div class="form-group">
                    <label>Farm</label>
                    <input
                        type="text"
                        class="form-control"
                        [value]="farms?.length ? farms[0]?.name : '-'"
                        readonly
                        disabled
                    />
                </div>
            </div>

            <!-- Chicks Numbers and Farm House -->
            <div class="col-md-6 mb-3">
                <label
                    >Chicks Numbers.<span class="text-danger-required"
                        >*</span
                    ></label
                >
                <input
                    type="number"
                    class="form-control"
                    formControlName="numberOfChicks"
                    placeholder=""
                    [ngClass]="{
                        'is-invalid': isControlInvalid('numberOfChicks'),
                        'is-valid':
                            !isControlInvalid('numberOfChicks') &&
                            mortalityForm.get('numberOfChicks').touched
                    }"
                />
                <div
                    *ngIf="
                        mortalityForm.get('numberOfChicks').invalid &&
                        mortalityForm.get('numberOfChicks').touched
                    "
                    class="text-danger"
                >
                    please add number of chicks
                </div>
                <span
                    class="text-danger"
                    *ngIf="mortalityForm.get('numberOfChicks').errors?.min"
                    >Value must be non-negative.</span
                >
            </div>

            <div class="col-md-6 mb-3">
                <label
                    >Farm House<span class="text-danger-required"
                        >*</span
                    ></label
                >
                <select
                    (change)="onFarmHouseChange($event.target.value)"
                    formControlName="farmHouseId"
                    class="form-control"
                    [ngClass]="{
                        'is-invalid': isControlInvalid('farmHouseId'),
                        'is-valid':
                            !isControlInvalid('farmHouseId') &&
                            mortalityForm.get('farmHouseId').touched
                    }"
                >
                    <option value="" disabled selected>Select</option>
                    <option *ngFor="let house of farmhouses" [value]="house.id">
                        {{ house.name }}
                    </option>
                </select>
                <div
                    *ngIf="
                        mortalityForm.get('farmHouseId').invalid &&
                        mortalityForm.get('farmHouseId').touched
                    "
                    class="text-danger"
                >
                    Please select a Farmhouse.
                </div>
            </div>

            <div class="col-md-6 mb-3">
                <label
                    >Partition<span class="text-danger-required">*</span></label
                >
                <select formControlName="partitionId" class="form-control">
                    <option value="0" disabled selected>Select</option>
                    <option *ngFor="let part of partitions" [value]="part.id">
                        {{ part.name }}
                    </option>
                </select>
                <div
                    *ngIf="
                        mortalityForm.get('partitionId').invalid &&
                        mortalityForm.get('partitionId').touched
                    "
                    class="text-danger"
                >
                    Please select a partition.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label
                    >Mortality Type<span class="text-danger-required"
                        >*</span
                    ></label
                >
                <select
                    formControlName="typeId"
                    class="form-control"
                    [ngClass]="{
                        'is-invalid': isControlInvalid('typeId'),
                        'is-valid':
                            !isControlInvalid('typeId') &&
                            mortalityForm.get('typeId').touched
                    }"
                >
                    <option value="" disabled selected>Select</option>
                    <option
                        *ngFor="let mortality of mortalities"
                        [value]="mortality.id"
                    >
                        {{ mortality.name }}
                    </option>
                </select>
                <div
                    *ngIf="
                        mortalityForm.get('typeId').invalid &&
                        mortalityForm.get('typeId').touched
                    "
                    class="text-danger"
                >
                    Please select a Type.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label
                    >Date & Time<span class="text-danger-required"
                        >*</span
                    ></label
                >
                <input
                    class="form-control"
                    formControlName="date"
                    type="datetime-local"
                    [ngClass]="{
                        'is-invalid': isControlInvalid('date'),
                        'is-valid':
                            !isControlInvalid('date') &&
                            mortalityForm.get('date').touched
                    }"
                />
                <div
                    *ngIf="
                        mortalityForm.get('date').invalid &&
                        mortalityForm.get('date').touched
                    "
                    class="text-danger"
                >
                    Please select date and time.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label
                    >Age (Days)<span class="text-danger-required"
                        >*</span
                    ></label
                >
                <input
                    type="number"
                    class="form-control"
                    formControlName="age"
                    placeholder="Enter age in days"
                    min="0"
                    [ngClass]="{
                        'is-invalid': isControlInvalid('age'),
                        'is-valid':
                            !isControlInvalid('age') &&
                            mortalityForm.get('age').touched
                    }"
                />
                <div
                    *ngIf="
                        mortalityForm.get('age').invalid &&
                        mortalityForm.get('age').touched
                    "
                    class="text-danger"
                >
                    Please enter age in days.
                </div>
                <span
                    class="text-danger"
                    *ngIf="mortalityForm.get('age').errors?.min"
                    >Age must be non-negative.</span
                >
            </div>
        </div>
        <div class="add-mortality-save text-center">
            <button
                class="btn btn-action-primary"
                type="submit"
                [disabled]="isLoading$ | async"
            >
                <span *ngIf="!isAuthLoading">Submit</span>
                <span *ngIf="isAuthLoading">Submitting...</span>
            </button>
        </div>
    </form>
</div>
